
<div class="page">
  <app-loader [isLoading]="loading"></app-loader>
    <app-page-title [titleKey]="'infoenfant.title'"></app-page-title>
    <div class="page-header">
      <app-children-selector (studentSelected)="onStudentSelected($event)"></app-children-selector>
    </div>
    <div class="tabs">
      <div
        class="tab"
        [class.active]="activeTab === 'profil'"
        (click)="setActiveTab('profil')"
      >
        🧑‍🎓 {{ "infoenfant.tabs.profil" | translate }}
      </div>
      <div
        class="tab"
        [class.active]="activeTab === 'famille'"
        (click)="setActiveTab('famille')"
      >
        👪 {{ "infoenfant.tabs.famille" | translate }}
      </div>
      <div
        class="tab"
        [class.active]="activeTab === 'ecole'"
        (click)="setActiveTab('ecole')"
      >
        🏫 {{ "infoenfant.tabs.ecole" | translate }}
      </div>
      <div
        class="tab"
        [class.active]="activeTab === 'sante'"
        (click)="setActiveTab('sante')"
      >
        🖤 {{ "infoenfant.tabs.sante" | translate }}
      </div>
      <div
        class="tab"
        [class.active]="activeTab === 'allergie'"
        (click)="setActiveTab('allergie')"
      >
        🌿 {{ "infoenfant.tabs.allergie" | translate }}
      </div>
    </div>

    <div class="sheet" *ngIf="activeTab === 'profil'">
      <div class="grid">

        <section class="avatar-wrap">
          <div class="avatar" id="avatar" (click)="triggerFileInput()" style="cursor: pointer;">
            <img [src]="profileForm.photo || 'assets/default-avatar.jpg'" (error)="onAvatarError($event)" alt="Student photo" />
            <div class="edit-icon-overlay">
              <i class="fas fa-pen"></i>
            </div>
          </div>
          <!-- Bouton pour choisir une photo -->
          <input type="file" id="fileInput" style="display: none;" (change)="onFileSelected($event)" accept="image/*" />
          <!-- Bouton pour envoyer la photo -->
          <button type="button" class="btn-primary" id="modAvatar" (click)="uploadPhoto()" [disabled]="!selectedFile" style="margin: 10px 5px;">
            {{ "infoenfant.profile.modify" | translate }}
          </button>
        </section>

        <form class="form" id="profileForm" (ngSubmit)="onSubmitProfile()">
          <div class="field">
            <label class="label">{{ 'infoenfant.profile.nameStudent' | translate }}</label>
            <input
              class="input"
              type="text"
              name="nameStudent"
              [(ngModel)]="profileForm.nameStudent"
              placeholder="{{ 'infoenfant.profile.placeholders.nom' | translate }}"
              required
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.arabicName' | translate }}</label>
            <input
              class="input"
              type="text"
              name="arabicName"
              [(ngModel)]="profileForm.arabicName"
              placeholder="{{ 'infoenfant.profile.placeholders.nomAr' | translate }}"
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.birthDate' | translate }}</label>
            <input
              class="input"
              type="text"
              [(ngModel)]="profileForm.birthDate"
              name="birthDate"
              [attr.aria-label]="'infoenfant.profile.birthDate' | translate"
              placeholder="{{
                'infoenfant.profile.birthDatePlaceholder' | translate
              }}"
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.birthPlace' | translate }}</label>
            <input
              class="input"
              type="text"
              name="birthPlace"
              [(ngModel)]="profileForm.birthPlace"
              placeholder="{{ 'infoenfant.profile.placeholders.lieu' | translate }}"
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.batchName' | translate }}</label>
            <input
              class="input"
              type="text"
              name="batchName"
              [(ngModel)]="profileForm.batchName"
              readonly
            />
          </div>

          <!-- Numéro de téléphone 1 (bloqué) -->
          <div class="field">
            <label class="label">{{ 'infoenfant.profile.fatherPhone1' | translate }}</label>
            <input
              class="input"
              type="text"
              name="fatherPhone"
              [(ngModel)]="profileForm.fatherPhone"
              placeholder="{{ 'infoenfant.profile.placeholders.fatherPhone1' | translate }}"
              readonly
            />
          </div>

          <!-- Numéro de téléphone 2 (modifiable) -->
          <div class="field">
            <label class="label">{{ 'infoenfant.profile.fatherPhone2' | translate }}</label>
            <input
              class="input"
              type="text"
              name="fatherPhone2"
              [(ngModel)]="profileForm.fatherPhone2"
              placeholder="{{ 'infoenfant.profile.placeholders.fatherPhone2' | translate }}"
              readonly
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.admissionNumber' | translate }}</label>
            <input
              class="input"
              type="text"
              name="admissionNumber"
              [(ngModel)]="profileForm.admissionNumber"
              placeholder="{{ 'infoenfant.profile.placeholders.admissionNumber' | translate }}"
              readonly
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.gender' | translate }}</label>
            <input
              class="input"
              type="text"
              name="gender"
              [(ngModel)]="profileForm.gender"
              placeholder="{{ 'infoenfant.profile.placeholders.gender' | translate }}"
              readonly
            />
          </div>

          <div class="field">
            <label class="label">{{ 'infoenfant.profile.nameOrg' | translate }}</label>
            <input
              class="input"
              type="text"
              name="nameOrg"
              [(ngModel)]="profileForm.nameOrg"
              placeholder="{{ 'infoenfant.profile.placeholders.nameOrg' | translate }}"
              readonly
            />
          </div>

          <div class="submit-row">
            <button class="btn-primary" type="submit">
              {{ "infoenfant.profile.modify" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="sheet" *ngIf="activeTab === 'famille'">
      <div class="page">
        <div class="sheet">
          <div class="content">
            <div class="cols">
              <!-- Père -->
              <section class="panel">
                <div class="head">
                  {{ "infoenfant.family.father" | translate }}
                </div>
                <div class="body">
                  <div class="grid2">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherLastName' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.lastName" name="fatherLastName">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherFirstName' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.firstName" name="fatherFirstName">
                    </div>

                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherAddress' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.adress" name="fatherAddress">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherLanguage' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.languParle" name="fatherLanguage">
                    </div>

                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherSituation' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.familyStuation" name="fatherSituation">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.fatherProfession' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.father.profession" name="fatherProfession">
                    </div>

                    <div class="field full">
                      <label class="label">{{ 'infoenfant.family.fatherEmail' | translate }}</label>
                      <input class="input" type="email" [(ngModel)]="familyForm.father.adressMail" name="fatherEmail">
                    </div>
                    

                  </div>
                </div>
              </section>

              <!-- Mère -->
              <section class="panel">
                <div class="head">
                  {{ "infoenfant.family.mother" | translate }}
                </div>
                <div class="body">
                  <div class="grid2">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherLastName' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.lastName" name="motherLastName">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherFirstName' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.firstName" name="motherFirstName">
                    </div>

                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherAddress' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.adress" name="motherAddress">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherLanguage' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.languParle" name="motherLanguage">
                    </div>

                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherSituation' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.familyStuation" name="motherSituation">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.family.motherProfession' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="familyForm.mother.profession" name="motherProfession">
                    </div>

                    <div class="field full">
                      <label class="label">{{ 'infoenfant.family.motherEmail' | translate }}</label>
                      <input class="input" type="email" [(ngModel)]="familyForm.mother.adressMail" name="motherEmail">
                    </div>

                  </div>
                </div>
              </section>
            </div>

            <!-- Dans la famille -->
            <section class="family">
              <div class="head">
                {{ "infoenfant.family.inFamily" | translate }}
              </div>
              <div class="body">
                <div class="row">
                  <div class="field">
                    <label class="label">{{ 'infoenfant.family.numberOfChildren' | translate }}</label>
                    <input
                      class="input"
                      type="number"
                      min="0"
                      [(ngModel)]="familyForm.childrenNumber"
                      name="childrenNumber"
                      placeholder="{{
                        'infoenfant.family.numberOfChildrenPlaceholder'
                          | translate
                      }}"
                    />
                  </div>
                  <div class="field">
                    <label class="label">{{ 'infoenfant.family.childRank' | translate }}</label>
                    <input
                      class="input"
                      type="text"
                      [(ngModel)]="familyForm.childRank"
                      name="childRank"
                      placeholder="{{
                        'infoenfant.family.childRankPlaceholder' | translate
                      }}"
                    />
                  </div>
                </div>
                <div class="row full" style="margin-top: 12px">
                  <div class="field">
                    <label class="label">{{ 'infoenfant.family.livesWithParents' | translate }}</label>
                    <select
                      class="input"
                      [(ngModel)]="familyForm.liveWithParents"
                      name="liveWithParents"
                    >
                      <option [ngValue]="true">{{ 'yes' | translate }}</option>
                      <option [ngValue]="false">{{ 'no' | translate }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </section>

            <div class="submit-wrap">
              <button class="btn" id="saveBtn" (click)="onSubmitFamilyData()">
                💾 {{ "infoenfant.family.save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet" *ngIf="activeTab === 'ecole'">
      <div class="page">
        <div class="sheet">
          <div class="content">
            <div class="cols">
              <!-- A l'école -->
              <section class="panel">
                <div class="head">{{ "infoenfant.school_data.atSchool" | translate }}</div>
                <div class="body">
                  <div class="stack">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.atKindergarten' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.oldJardinKind" name="oldJardinKind"><option [ngValue]="true">Oui</option><option [ngValue]="false">Non</option></select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.atPreparatoryClass' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.haveBeenToPreparatoire" name="haveBeenToPreparatoire"><option [ngValue]="true">Oui</option><option [ngValue]="false">Non</option></select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.wasInAnotherSchool' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.transfered" name="transferred"><option [ngValue]="true">Oui</option><option [ngValue]="false">Non</option></select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.startingLevel' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.startingLevel" name="startingLevel">
                        <option>6 éme année</option>
                        <option>5 éme année</option>
                        <option>4 éme année</option>
                        <option>3 éme année</option>
                        <option>2 éme année</option>
                        <option>1 ére année</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.reasonsForJoining' | translate }}</label>
                      <textarea class="textarea" [(ngModel)]="schoolForm.transfertReason" name="transferReason"></textarea>

                    </div>
                  </div>
                </div>
              </section>

              <!-- Sorties organisées -->
              <section class="panel">
                <div class="head">{{ "infoenfant.school_data.organizedTrips" | translate }}</div>
                <div class="body">
                  <div class="stack">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.organizedTripsDescription' | translate }}</label>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.agreeChildParticipation' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.allowTripOcaPar" name="allowTripOcaPar">
                        <option [ngValue]="true">Oui</option>
                        <option [ngValue]="false">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.school_data.agreeParentParticipation' | translate }}</label>
                      <select class="select" [(ngModel)]="schoolForm.allowTripPermPar" name="allowTripPermPar"><option [ngValue]="true">Oui</option><option [ngValue]="false">Non</option></select>

                    </div>
                  </div>
                </div>
              </section>
            </div>
          
          <!-- Emergency contacts -->
          <section class="emergency">
            <div class="head">{{ 'infoenfant.school.emergencyContacts' | translate }}</div>
            <div class="body">
              <div class="field">
                <label class="label">{{ 'infoenfant.profile.placeholders.nom' | translate }}</label>
                <input class="input" type="text" [(ngModel)]="familyForm.emergencyContacts[0].firstName" name="emergencyFirstName">
              </div>
              <div class="field">
                <label class="label">{{ 'infoenfant.profile.placeholders.prenom' | translate }}</label>
                <input class="input" type="text" [(ngModel)]="familyForm.emergencyContacts[0].lastName" name="emergencyLastName">
              </div>
              <div class="field">
                <label class="label">{{ 'infoenfant.school.relationWithStudent' | translate }}</label>
                <input class="input" type="text" [(ngModel)]="familyForm.emergencyContacts[0].childRelative" name="emergencyChildRelative">
              </div>
              <div class="field">
                <label class="label">{{ 'infoenfant.school.mobilePhone' | translate }}</label>
                <input class="input" type="tel" [(ngModel)]="familyForm.emergencyContacts[0].mobile" name="emergencyMobile">
              </div>
              <div class="checks full">
                <label class="check">
                  <input type="checkbox" [(ngModel)]="familyForm.emergencyContacts[0].emmergencyCall" name="emergencyEmmergencyCall">
                  {{ 'infoenfant.school.callInEmergency' | translate }}
                </label>
                <label class="check">
                  <input type="checkbox" [(ngModel)]="familyForm.emergencyContacts[0].takeAfterSchool" name="emergencyTakeAfterSchool">
                  {{ 'infoenfant.school.authorizedToPickUp' | translate }}
                </label>
              </div>
            </div>
          </section>


            <div class="submit-wrap">
              <button class="btn" id="saveBtn" (click)="onSubmitSchoolData()">
                💾 {{ "infoenfant.school.save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="sheet" *ngIf="activeTab === 'sante'">
      <div class="page">
        <div class="sheet">
          <div class="content">
            <div class="cols">
              <!-- LEFT PANEL : Comportement de l'enfant -->
              <section class="panel">
                <div class="head">{{ 'infoenfant.health.childBehavior' | translate }}</div>
                <div class="body">
                  <div class="stack">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.prefersToPlay' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.playMode" name="playMode">
                        <option value="Seul">Seul</option>
                        <option value="En groupe">En groupe</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.favoriteGames' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.games" name="games" placeholder="{{ 'infoenfant.health.enterFavoriteGames' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.mostOften' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.behaviour" name="behaviour">
                        <option value="Calme">Calme</option>
                        <option value="Parfois agressive">Parfois agressive</option>
                        <option value="Toujours agressive">Toujours agressive</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.expressesWithTears' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.cryAttitude" name="cryAttitude">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.isShy' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.shyAttitude" name="shyAttitude">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.isLeader' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.meneur" name="meneur">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.isIntroverted' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.introverti" name="introverti">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.isOftenNervous' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.nervous" name="nervous" (change)="onNervousChange()">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field" *ngIf="showNervousDetails()">
                      <label class="label">{{ 'infoenfant.health.whenIrritable' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.irritManifest" name="irritManifest">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.hasParticularHabits' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.notesDeComportement" name="notesDeComportement" placeholder="{{ 'infoenfant.health.describeParticularHabits' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.dressesAlone' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.dresseAllown" name="dresseAllown">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.goodAppetite' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.enjoyMeal" name="enjoyMeal">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.eatsEverything' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.eatEvreything" name="eatEvreything">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.dislikesFood' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.aliments" name="aliments" (change)="onAlimentsChange()">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field" *ngIf="showAlimentsDetails()">
                      <label class="label">{{ 'infoenfant.health.whichFood' | translate }}</label>
                      <input class="input" type="text" [(ngModel)]="healthForm.detestedMeal" name="detestedMeal" placeholder="{{ 'infoenfant.health.specifyDislikedFood' | translate }}" />
                    </div>
                  </div>
                </div>
              </section>

              <!-- RIGHT PANEL : Santé de l'enfant -->
              <section class="panel">
                <div class="head">{{ 'infoenfant.health.childHealth' | translate }}</div>
                <div class="body">
                  <div class="stack">
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.childHealthStatus' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.health" name="health">
                        <option value="failbe">Faible</option>
                        <option value="moyenne">Moyenne</option>
                        <option value="excellente">Excellente</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.hospitalized' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.hospitalized" name="hospitalized" (change)="onHospitalizedChange()">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field" *ngIf="showHospitalDetails()">
                      <label class="label">{{ 'infoenfant.health.hospitalizationAge' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.hospitalReason" name="hospitalReason" placeholder="{{ 'infoenfant.health.reasonForHospitalization' | translate }}">
                    </div>
                    <div class="field" *ngIf="showHospitalDetails()">
                      <label class="label">{{ 'infoenfant.health.walkingAge' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.walkingAge" name="walkingAge" placeholder="{{ 'infoenfant.health.ageInMonths' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.followedByDentist' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.dentalRecord" name="dentalRecord">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.foodAllergies' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.allergie" name="allergie">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.frequentFevers' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.fever" name="fever">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.hasConvulsions' | translate }}</label>
                      <select class="select" [(ngModel)]="healthForm.convulsion" name="convulsion">
                        <option value="oui">Oui</option>
                        <option value="non">Non</option>
                      </select>
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.childBloodType' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.bloodType" name="bloodType" placeholder="{{ 'infoenfant.health.bloodTypePlaceholder' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.doctorsName' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.nameOfDoctor" name="nameOfDoctor" placeholder="{{ 'infoenfant.health.doctorName' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.doctorsContactInfo' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.adressDoctor" name="adressDoctor" placeholder="{{ 'infoenfant.health.doctorsContactInfoPlaceholder' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.contractedDisease' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.disease" name="disease" placeholder="{{ 'infoenfant.health.contractedDiseasePlaceholder' | translate }}">
                    </div>
                    <div class="field">
                      <label class="label">{{ 'infoenfant.health.unforeseenProblems' | translate }}</label>
                      <input type="text" class="input" [(ngModel)]="healthForm.extraProblem" name="extraProblem" placeholder="{{ 'infoenfant.health.unforeseenProblemsPlaceholder' | translate }}">
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <!-- Save Button -->
            <div class="submit-wrap">
              <button class="btn" type="button" (click)="onSubmitHealthData()">
                💾 {{ 'infoenfant.health.save' | translate }}
              </button>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="sheet" *ngIf="activeTab === 'allergie'">
      <div class="page">
        <div class="sheet">
          <div class="content">
            <section class="panel">
              <div class="head">🌿 {{ "infoenfant.allergy.title" | translate }}</div>
              <div class="body">
                <!-- Add new allergy section -->
                <div class="field" *ngIf="availableAllergies.length > 0">
                  <label class="label">{{ "infoenfant.allergy.add" | translate }}</label>
                  <div class="add-allergy-section">
                    <select class="select" [(ngModel)]="selectedNewAllergy" name="newAllergy" (ngModelChange)="onAllergySelected($event)">
                      <option value="">{{ "infoenfant.allergy.choose" | translate }}</option>
                      <option *ngFor="let allergy of availableAllergies" [value]="allergy.id">
                        {{ allergy.nomFr }} <span *ngIf="allergy.nomAr">({{ allergy.nomAr }})</span>
                      </option>
                    </select>
                  </div>
                </div>

                <!-- Current allergies section -->
                <div class="field">
                  <label class="label">{{ "infoenfant.allergy.current" | translate }}</label>
                  <div class="allergy-grid" *ngIf="allergiesList.length > 0">
                    <div class="allergy-card" *ngFor="let allergy of allergiesList">
                      <div class="allergy-info">
                        <div class="allergy-name-fr">{{ allergy.nomFr }}</div>
                        <div class="allergy-name-ar" *ngIf="allergy.nomAr">{{ allergy.nomAr }}</div>
                      </div>
                      <button class="delete-allergy-btn" (click)="deleteAllergy(allergy.id)" title="Supprimer">
                        🗑️
                      </button>
                    </div>
                  </div>
                  <div class="no-allergies-message" *ngIf="allergiesList.length === 0">
                    <div class="empty-state">
                      <span class="empty-icon">🌿</span>
                      <span class="empty-text">{{ "infoenfant.allergy.none" | translate }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="submit-wrap">
              <button class="btn" type="button" (click)="onSubmitAllergy()">
                💾 {{ "infoenfant.allergy.save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

</div>